
import {defineComponent, PropType} from "vue";
import {generateContentPreviewUrl} from "@/helpers/functions/route";
import {formatDateToLocalFormat} from "@/helpers/functions/date-time";
import {UtilityHelper} from "@/helpers/UtilityHelper";
import {ContentPreviewOverviewRestDto} from "@/api/pharma-cms-content-preview/models";

export default defineComponent({
  name: "ContentPreviewOverviewItem",
  props: {
    contentPreview: {
      type: Object as PropType<ContentPreviewOverviewRestDto>,
      required: true
    },
  },
  computed: {
    previewPath(): string | null {
      return generateContentPreviewUrl(this.contentPreview.preview_key);
    },
    validityPeriod(): string {
      const beginDate = this.contentPreview.begin_date;
      const endDate = this.contentPreview.end_date;

      if (beginDate && endDate) {
        return `${formatDateToLocalFormat(beginDate)} ${this.$t('till').toLowerCase()} ${formatDateToLocalFormat(endDate)}`;
      }
      if (beginDate) {
        return `${this.$t('asOf')} ${formatDateToLocalFormat(beginDate)}`;
      }
      if (endDate) {
        return `${this.$t('till')} ${formatDateToLocalFormat(endDate)}`;
      }

      return this.$t('notSet');
    },
  },
  methods: {
    async copyPreviewLink(): Promise<void> {
      if (!this.previewPath) {
        return;
      }

      await UtilityHelper.copyToClipboard(this.previewPath);
    },
  },
});
